import React, { Component } from 'react';
import mobile from 'is-mobile';
import Presenter from './presenter';
import Model from './model';
import View from './view';

export default class Login extends Component {
  constructor(props) {
    super(props);
    const { config, removeLoader } = props;
    const showMobileOnly =
      (config.view_mode === 'mobile-only' || config.view_mode === 'mobile-first') &&
      !mobile({ featureDetect: true, tablet: true });

    this.presenter = new Presenter(
      new Model(this, {
        index: View.Page.landing,
        config,
        notificationType: null,
        showMobileOnly,
        initialToken: '',
      }),
      config,
      removeLoader
    );
  }

  componentDidMount() {
    this.presenter.onAttach();
  }

  componentDidUpdate(prevProp) {
    if (this.props !== prevProp) {
      const { hash, config } = this.props;
      this.presenter.update(hash, config);
    }
  }

  render() {
    return <View {...this.state} presenter={this.presenter} />;
  }
}
